// @ts-ignore
import Cookies from "js-cookie";
import { defineStore } from "pinia";

import { logoutApi } from "@/api/auth";
import { getUserInfo } from "@/api/user";
import { LoginUser, UserInfo } from "@/api/user/types";
import { goLogin } from "@/router";
import { store } from "@/store";

export const useUserStore = defineStore("user", () => {
  // state
  const userId = ref();
  const tokens = reactive({
    accessToken: "",
    refreshToken: "",
    expiresIn: "",
  });
  const userInfo = ref<LoginUser>({} as LoginUser); // 用户信息
  const roles = ref<Array<number>>([]); // 用户角色编码集合 → 判断路由权限
  const perms = ref<Array<string>>([]); // 用户权限编码集合 → 判断按钮权限
  const deptName = ref<string>(""); // 用户部门名称

  getTokensFromSessionStorage();
  function getTokensFromSessionStorage() {
    tokens.accessToken = Cookies.get("access_token") ?? "";
    tokens.refreshToken = Cookies.get("refresh_token") ?? "";
    tokens.expiresIn = Cookies.get("expires_in") ?? "";
  }

  function set2Cookie() {
    // 过期时间，如果没有则默认12小时
    const expires = Number(tokens.expiresIn ?? 43200) / 60 / 60 / 24;
    Cookies.set("access_token", tokens.accessToken, { expires });
    Cookies.set("refresh_token", tokens.refreshToken, { expires });
  }

  function clearTokens() {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  }

  function updateToken({ accessToken, refreshToken, expiresIn }: any = {}) {
    tokens.accessToken = accessToken;
    tokens.refreshToken = refreshToken;
    tokens.expiresIn = expiresIn;
    set2Cookie();
  }

  // 获取信息(用户昵称、头像、角色集合、权限集合)
  function getInfo() {
    return new Promise<UserInfo>((resolve, reject) => {
      getUserInfo()
        .then(({ data }) => {
          userInfo.value = data.sysUser;
          roles.value = data.roles;
          perms.value = data.permissions;
          deptName.value = data.deptName;

          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // 注销
  function logout() {
    return new Promise<void>((resolve, reject) => {
      logoutApi()
        .then(() => {
          ElMessage.success("退出登录成功");
          goLogin();
          resetAll();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // 重置
  function resetAll() {
    tokens.accessToken = "";
    tokens.refreshToken = "";
    tokens.expiresIn = "";
    userInfo.value = {} as LoginUser;
    roles.value = [];
    perms.value = [];
    clearTokens();
  }
  return {
    tokens,
    userInfo,
    deptName,
    roles,
    perms,
    getInfo,
    logout,
    resetAll,
    /**
     * 当前登录用户ID
     */
    userId,
    updateToken,
  };
});

// 非setup
export function useUserStoreHook() {
  return useUserStore(store);
}
